import { useMemo } from 'react';

import {
  CONTENT_WITHOUT_BG_STYLES,
  type ScreenOptions,
  type ScreenOptionsMap,
} from '../../../../constants';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Screen options for the transparent modals stack.
 *
 * Unlike `(modals)`, this stack is always presented transparently, so its
 * screens render over the one beneath them rather than covering it. The
 * presentation is static on purpose: iOS resolves it when the stack is first
 * presented, so deriving it from the active route arrives a render too late.
 */
export const useTransparentModalStackOptions = () => {
  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: {
        headerShown: false,
        contentStyle: CONTENT_WITHOUT_BG_STYLES,
        animation: 'fade',
      } satisfies ScreenOptions,
    } satisfies ScreenOptionsMap;
  }, []);
};
